import { render } from "./SideNav.vue?vue&type=template&id=1f63e550&scoped=true"
import script from "./SideNav.script.js?vue&type=script&lang=js&external"
export * from "./SideNav.script.js?vue&type=script&lang=js&external"

import "./SideNav.style.css?vue&type=style&index=0&id=1f63e550&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f63e550"]])

export default __exports__